<template>
  <div class="">
    <a :href="content.link" class="o-homepage-card trip-ideas">
      <div v-if="content.image">
        <div class="o-homepage-card__image u-bg-img" :style="'background-image: url('+content.image+');'" alt="Visit Waterford">
        </div>
      </div>
      <div v-else >
        <div class="o-homepage-card__image u-bg-img" style="background-image: url('/wp-content/themes/visitwaterford/assets/images/default-image.png');" alt="Visit Waterford">
        </div>
      </div>

      <div class="simplefavorite-button-container ">
        <button  class="simplefavorite-button  fav-plugin o-favourite-button " :data-postid="content.id" data-siteid="1" data-groupid="1" data-favoritecount="2" style=""><i class="sf-icon-star-empty"></i></button>
      </div>

      <div class="o-homepage-card__text trip">
        {{content.title}}
        <div class="trip-details">
          <span v-if="content.days">{{content.days}} DAY<span v-if="content.days > 1">S</span></span>
          <span v-if="content.km">{{content.km}} KM </span>
          <span v-if="content.km">{{Math.round(content.km * 0.6213712)}} MILES </span>
          <span v-if="content.triplocations">{{content.triplocations}} LOCATION<span v-if="content.triplocations > 1">S</span></span>
        </div>

      </div>
    </a>
  </div>


</template>

<script>

  export default {

    name: 'ExperienceCard',

    props: {
      content: {
        type: Object,
      }
    },

    mounted () {
      this.callFoundation();
      // console.log(this.content.categories)
    },

    methods: {
        // Renit foundation components
      callFoundation () {
        this.$nextTick(() => {
          $(this.$el).foundation();
          // Foundation.reInit('data-accordion')
        })
      },
      //Favourite Animation load
      // favAnimation () {
      //     let filteredText = $(this.$el).text().slice(0, 10).replace(/ /g,'');
      //     console.log(filteredText);
      //   if (filteredText == 'Favorite') {
      //     $(this.$el).addClass('favourites-feedback');
      //     console.log('Favourite added');
      //   }
      //   setTimeout(function() {
      //       $(this.$el).removeClass('favourites-feedback');
      //       $(this.$el).addClass('no-fav');
      //      }, 7000);
      // }
    }
  };
</script>



// WEBPACK FOOTER //
// src/js/vue/vue-partials/experience-card.vue